import { AnimatePresence, motion } from 'motion/react'
import { Drawer } from 'vaul'
import useLockBodyScroll from '@/hooks/useLockBodyScroll'
import useEscapeKey from '@/hooks/useEscapeKey'
import useIsDesktop from '@/hooks/useIsDesktop'

const MAX_WIDTH = {
    sm: 'max-w-[400px]',
    lg: 'max-w-[600px]',
}

export default function ResponsiveDrawer({ isOpen, onClose, size = 'sm', children }) {
    const isDesktop = useIsDesktop()
    useLockBodyScroll(isOpen && isDesktop)
    useEscapeKey(isOpen, onClose)

    if (!isDesktop) {
        return (
            <Drawer.Root
                open={isOpen}
                onOpenChange={(open) => {
                    if (!open) onClose()
                }}
            >
                <Drawer.Portal>
                    <Drawer.Overlay className="fixed inset-0 bg-black/10 backdrop-blur-[20px] z-30" />
                    <Drawer.Content className="fixed bottom-0 left-0 right-0 z-40 bg-white rounded-t-[16px] max-h-[95vh] flex flex-col outline-none">
                        <div className="flex justify-center pt-[12px] pb-[4px]">
                            <div className="w-[36px] h-[4px] rounded-full bg-dark-blue-10" />
                        </div>
                        {children}
                    </Drawer.Content>
                </Drawer.Portal>
            </Drawer.Root>
        )
    }

    return (
        <AnimatePresence>
            {isOpen && (
                <>
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        onClick={onClose}
                        className="fixed inset-0 bg-black/10 backdrop-blur-[20px] z-30"
                    />

                    <motion.aside
                        initial={{ x: '100%' }}
                        animate={{ x: 0 }}
                        exit={{ x: '100%' }}
                        transition={{
                            type: 'spring',
                            bounce: 0,
                            duration: 0.4,
                        }}
                        className={`fixed top-0 right-0 bottom-0 z-40 w-full ${MAX_WIDTH[size]} flex flex-col p-[12px]`}
                    >
                        <div className="bg-white rounded-[8px] h-full flex flex-col">
                            {children}
                        </div>
                    </motion.aside>
                </>
            )}
        </AnimatePresence>
    )
}
